import { Link } from "react-router";
import { ContactLink, LegalLayout } from "./PrivacyPage";

/** Public account-deletion instructions: the "delete account" URL on the Play listing. */
export function DeleteAccountPage() {
  return (
    <LegalLayout title="Deleting your ten20 account">
      <p>You can delete your ten20 account and its data yourself at any time, from the web or the Android app.</p>

      <h2>On the web</h2>
      <ol>
        <li>
          <Link to="/login?next=%2Faccount">Sign in</Link> and open your <Link to="/account">account page</Link>.
        </li>
        <li>Under &quot;Your data&quot;, choose &quot;Delete account…&quot;.</li>
        <li>Type your email address to confirm, then delete.</li>
      </ol>

      <h2>In the Android app</h2>
      <ol>
        <li>Open the ten20 app and tap the settings (gear) button on the map.</li>
        <li>Tap your name at the top of Settings to open &quot;Account&quot;.</li>
        <li>Choose &quot;Delete account&quot;, type your email address to confirm, then delete.</li>
      </ol>

      <h2>What is deleted</h2>
      <p>
        Deletion is immediate and cannot be undone. Your profile, sign-ins, devices and passkeys, location history,
        place arrivals and departures, daily summaries, latest location, the days you used ten20, alert settings,
        emergency contacts and integration tokens are deleted. Circles where you are the only member are deleted; in
        shared circles you are removed, and if you were the only admin the longest-standing member becomes admin. Places
        belong to their circle, so places in shared circles stay. Other members see that a &quot;Deleted account&quot;
        left. Your chat reactions, chat settings and blocks are deleted; messages you sent stay in other people&apos;s
        chats, shown as from &quot;Deleted account&quot;, so unsend any you want gone first. Usage totals already
        counted stay, as they hold nothing that identifies you. Backups are overwritten within their limited retention
        period.
      </p>
      <p>
        Before deleting, you can download a copy of your data from the same account page. If you can no longer sign in,
        email <ContactLink /> from the address on the account and we will delete it for you.
      </p>
    </LegalLayout>
  );
}
